import NFT from "./NFT.js";
import Auth from "./Auth.js";
import { combineReducers } from "redux";

export default combineReducers({
  Auth, NFT,
});
